import React, { Component, PropTypes } from 'react';
import A from 'aphrodite';
import { connect } from 'react-redux';
import { TextField, RaisedButton, IconButton, Checkbox } from 'material-ui';

const styles = A.StyleSheet.create({
  searchContainer: { width: '90%', display: 'flex' },
  searchBox: { border: '1px solid #00bcd4', display: 'flex', borderRadius: '2px', height: '34px', justifyContent: 'space-between', backgroundColor: 'white' },
});
const propTypes = {
  isSingleLocation: PropTypes.bool,
  search: PropTypes.func,
  pathBeforeSearch: PropTypes.string,
  companyType: PropTypes.string,
  changeRoute: PropTypes.func,
  searchParams: PropTypes.object,
  updateSearchParams: PropTypes.func,
};
class FuzzySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: props.searchParams.searchInput || '',
      showRateContainers: props.searchParams.showRateContainers || false,
      showArchivedDeleted: props.searchParams.showArchivedDeleted || false,
    };
  }
  setStateAndDosearch = updater => this.setState(updater, this.doSearch);
  doSearch = () => this.props.search({ ...this.props.searchParams, searchingAllYears: true, ...this.state });
  render() {
    const { isSingleLocation, pathBeforeSearch, changeRoute, companyType } = this.props;
    const showOptions = Boolean(this.state.searchInput && companyType === 'Contractor');
    return (
      <div className={`${A.css(styles.searchContainer)}`}>
        <div className={`fuzzySearch ${A.css(styles.searchBox)}`} style={{ width: showOptions ? 'calc(100% - 420px)' : '100%' }}>
          <TextField
            hintText={`Search Company, Email${isSingleLocation ? '' : ', Property Name'}...`}
            value={this.state.searchInput}
            inputStyle={{ bottom: '2px' }}
            style={{ width: '70%', height: '35px', marginLeft: '4px' }}
            hintStyle={{ bottom: '6px', fontSize: '13px' }}
            onKeyDown={e => {
              if (e.keyCode === 13) this.doSearch();
            }}
            underlineShow={false}
            onChange={(_, value) => this.setState({ searchInput: value })}
          />
          <IconButton
            iconClassName="tc-icon-close"
            iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}
            style={{ padding: '0', top: '4px', height: '34px', display: this.state.searchInput ? 'inline-block' : 'none' }}
            onTouchTap={() => {
              this.setState({ searchInput: '' });
              changeRoute(pathBeforeSearch || 'recent');
            }}
          />
          <RaisedButton
            label="Search All Periods"
            labelStyle={{ top: '-1px' }}
            style={{ height: '32px', minWidth: '185px', width: '185px' }}
            overlayStyle={{ height: '32px' }}
            buttonStyle={{ height: '32px', lineHeight: '32px' }}
            secondary
            onClick={this.doSearch}
          />
        </div>
        <div style={{ width: '420px', display: showOptions ? 'flex' : 'none', paddingLeft: '1em' }} className="flex-center">
          <Checkbox
            label="Show Archived or Deleted"
            checked={this.state.showArchivedDeleted}
            labelStyle={{ fontSize: '12px' }}
            style={{ width: '220px' }}
            onCheck={() => this.setStateAndDosearch({ showArchivedDeleted: !this.state.showArchivedDeleted })}
          />
          <Checkbox
            label="Show Workspaces"
            checked={this.state.showRateContainers}
            labelStyle={{ fontSize: '12px' }}
            style={{ width: '200px' }}
            onCheck={() => this.setStateAndDosearch({ showRateContainers: !this.state.showRateContainers })}
          />
      </div>
      </div>
    );
  }
}
FuzzySearch.propTypes = propTypes;
const mapStateToProps = ({ user, contracting }) => ({
  companyType: user.getIn(['user', 'type']),
  folders: contracting.contractList.get('folders').toJS(),
  isSingleLocation: user.getIn(['user', 'company', 'oneOrMultiProperties']),
  pathBeforeSearch: contracting.contractList.get('pathBeforeSearch'),
});

export default connect(mapStateToProps)(FuzzySearch);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/top-bar/fuzzy-search.jsx